import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";
export default async function delayTrip(trip_id, reason, time, component) {
  console.log("checkfast", trip_id, reason, time);
  const Authorization = "bearer " + localStorage.getItem("token");

  const resp = await fetch(`${API_URL}rest/V1/rider/tripDelay`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      data: {
        jobId: trip_id,
        reason: reason,
        time: time,
      },
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("delayorder", data);
      if (data && data[0] && data[0].status != "failure") {
        component.props.delayOrderAction(data);
        return data;
      } else {
        notify.show(
          data && data[0] && data[0].message
            ? data[0].message
            : "Delay report failed",
          "error"
        );
      }
      // api.callShippingJobs(component,trip_id);delayOrderAction
    });
  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/delayTrip.js